import { createContext, useContext } from 'react';
import type { Layout } from './useLayout';

export interface ShellApi {
  layout: Layout;
  /** đầu trang đã thu gọn (đã cuộn) */
  condensed: boolean;
  /** `main` — vùng cuộn của trang (null trước khi gắn) */
  scrollRoot: HTMLElement | null;
  openFind: () => void;
  /** nút Tìm nhanh trên đầu trang (app riêng rail có nhãn như Mint-Mee không có; Ctrl K vẫn mở) */
  findButton: boolean;
  openNav: () => void;
  /** điện thoại: mở bảng "Thêm · Góp ý" (nút 48 ở đầu trang của board có `data-fkmore`) */
  openFbMore: () => void;
  /** người đăng nhập có cờ ADMIN (vùng chỉ ADMIN như HANA Kit hiện `noperm` khi false) */
  admin: boolean;
}
export const ShellCtx = createContext<ShellApi | null>(null);
export function useShell(): ShellApi {
  const c = useContext(ShellCtx);
  if (!c) throw new Error('useShell cần nằm trong <AppShell>');
  return c;
}

/** Vùng cuộn của trang (`main`), để màn có cuộn ảo nghe `scroll` mà không tự đoán. null trước khi gắn. */
export function useScrollRoot(): HTMLElement | null {
  return useShell().scrollRoot;
}
